import Link from '../Link';
import { mailTo, pressEmail } from '../../helpers';
import Wrapper from '../Wrapper/Wrapper';
import React from 'react';

const PressOpportunitiesHeader = () => (
  <Wrapper textAlign="center" font={'"Avenir", "Arial", sans-serif'} fontSize="15px" margin="0 60px 0 60px" fontWeight="300" lineHeight="20px">
    For press opportunities, please email{' '}
    <Link fontSize="15px" href={mailTo(pressEmail)}>
      {pressEmail}
    </Link>
  </Wrapper>
);

export default PressOpportunitiesHeader;
